export enum DiaryType {
  Periodic = 0,
  OnboardingQuestions = 1,
  IntraDay = 2
}
